import { request } from './apiClient';
import { getSessionClientId } from './authSession';

const onlyDigits = (value) => (value || '').replace(/\D/g, '');

// Monta o payload de usuário (camelCase) com cliente da sessão e empresa padrão "Kretos Lab".
// AJUSTE BACKEND AQUI: mapeamento do formulario para o contrato da API de usuarios.
export const buildUserPayload = (formData, cepDigits) => ({
  nomeCompleto: formData.nomeCompleto.trim(),
  numrCpf: onlyDigits(formData.numrCpf),
  endereco: formData.endereco.trim(),
  codgCep: cepDigits ? Number(cepDigits) : null,
  numrTelefone: onlyDigits(formData.numrTelefone),
  enderecoEmail: formData.enderecoEmail.trim(),
  descSenha: formData.descSenha,
  urlLinkedin: formData.urlLinkedin.trim() || null,
  urlInstagram: formData.urlInstagram.trim() || null,
  idCidade: formData.idCidade ? Number(formData.idCidade) : null,
  role: formData.role,
  empresa: formData.empresa.trim() || 'Kretos Lab',
  responsavelTipo: formData.responsavelTipo || 'geral',
  idCliente: getSessionClientId() || null,
});

// Lista todos os usuários.
export const getUser = async (idCliente) => {
  // AJUSTE BACKEND AQUI: endpoint de listagem de usuarios.
  const effectiveClientId = idCliente || getSessionClientId();
  return await request(`/api/Usuario?idCliente=${effectiveClientId}`);
};

// Cria um usuário; retorna { response, payload }.
export const creatUser = async (formData, cepDigits) => {
  const payload = buildUserPayload(formData, cepDigits);

  // AJUSTE BACKEND AQUI: endpoint de criacao de usuario.
  const response = await request('/api/Usuario', {
    method: 'POST',
    body: JSON.stringify(payload)
  });

  return { response, payload };
};

// Atualiza o usuário por id; retorna { response, payload }.
export const updateUser = async (idUsuario, formData, cepDigits) => {
  const payload = buildUserPayload(formData, cepDigits);

  // AJUSTE BACKEND AQUI: update por id do usuario.
  const response = await request(`/api/Usuario/${idUsuario}`, {
    method: 'PUT',
    body: JSON.stringify(payload)
  });

  return { response, payload };
};

// Exclui o usuário por id.
export const deleteUser = async (idUsuario) => {
  // AJUSTE BACKEND AQUI: exclusao por id do usuario.
  return await request(`/api/Usuario/${idUsuario}`, {
    method: 'DELETE'
  });
};

// --- Assinatura/carimbo do usuário (rodapé dos relatórios em PDF) -------------------------------
// Uma assinatura por usuário (upsert). A empresa vincula até dois usuários assinantes.

// Envia/substitui a assinatura do usuário. `file` é um File. Retorna { dataUri, nome, criadoEm }.
export const uploadAssinaturaUsuario = async (idUsuario, file) => {
  const formPayload = new FormData();
  formPayload.append('arquivo', file);
  // AJUSTE BACKEND AQUI: PUT /api/Usuario/{id}/assinatura (multipart, campo "arquivo").
  return await request(`/api/Usuario/${idUsuario}/assinatura`, { method: 'PUT', body: formPayload });
};

// Busca a assinatura do usuário como data URI base64. Retorna null quando não há (204).
export const getAssinaturaUsuario = async (idUsuario) => {
  // AJUSTE BACKEND AQUI: GET /api/Usuario/{id}/assinatura -> { dataUri, nome, criadoEm } | 204.
  return await request(`/api/Usuario/${idUsuario}/assinatura`);
};

// Remove a assinatura do usuário.
export const deleteAssinaturaUsuario = async (idUsuario) => {
  // AJUSTE BACKEND AQUI: DELETE /api/Usuario/{id}/assinatura.
  return await request(`/api/Usuario/${idUsuario}/assinatura`, { method: 'DELETE' });
};

// Indica se o usuário tem assinatura gravada.
// AJUSTE BACKEND AQUI: flag `possuiAssinatura` na listagem de usuários.
export const usuarioPossuiAssinatura = (user) => Boolean(
  user && (user.possuiAssinatura ?? user.possui_assinatura ?? user.temAssinatura)
);
